import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=b50bb2e4&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=b50bb2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50bb2e4",
  null
  
)

export default component.exports